import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Button } from "react-bootstrap"
import { GetDetalleGarantiaLocatario, ValidacionBancoEmail } from '../../../../api/Api';
import GarantiaInfo from "../../../../Components/Garantias/GarantiaInfo";
import CheckTesoreriaModal from './CheckTesoreriaModal';
import { useGetUser } from "../../../../Hooks/CustomHooks"
import { GARANTIA_ESTADO, GARANTIA_ROL, GARANTIA_TIPO } from "../../../Utils/Constants"
import CheckCobranzaModal from './CheckCobranzaModal';
import ConfirmWithLoader from '../../../../Components/Modals/ConfirmWithLoader';
import { useQueryClient } from 'react-query';
import { PageTitle } from '../../../../../_metronic/layout/core';
import cogoToast from "cogo-toast";

export default function RevisionGarantia(data) {
    const { id } = useParams();
    const [garantiaData, setGarantiaData] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const user = useGetUser()

    const [showValidacionBancoModal, setShowValidacionBancoModal] = useState(false);
    const [isLoadingValidacionBanco, setIsLoadingValidacionBanco] = useState(false);
    const [isFinishValidacionBanco, setIsFinishValidacionBanco] = useState(false);
    const [isErrorValidacionBanco, setIsErrorValidacionBanco] = useState(false);

    const queryClient = useQueryClient();

    const getDetalleGarantiaLocatario = useCallback((id) => {
        GetDetalleGarantiaLocatario(id).then((response) => {
            console.info(response.data, "RESPONSE DATA");
            let nombreBanco = null;
            let urlFileNameAdjuntoExcepcion = null;
            let fileNameAdjuntoExcepcion = null;

            if (response.data.detalle_garantia.excepcion.nombre_banco_carta_fianza) {
                nombreBanco = response.data.detalle_garantia.excepcion.nombre_banco_carta_fianza;
            } else if (response.data.detalle_garantia.excepcion.nombre_banco_efectivo) {
                nombreBanco = response.data.detalle_garantia.excepcion.nombre_banco_efectivo;
            }

            if (response.data.detalle_garantia.excepcion.url_file_name_carta_fianza) {
                urlFileNameAdjuntoExcepcion = response.data.detalle_garantia.excepcion.url_file_name_carta_fianza;
                fileNameAdjuntoExcepcion = response.data.detalle_garantia.excepcion.file_name_carta_fianza;
            } else if (response.data.detalle_garantia.excepcion.url_file_name_efectivo) {
                urlFileNameAdjuntoExcepcion = response.data.detalle_garantia.excepcion.url_file_name_efectivo;
                fileNameAdjuntoExcepcion = response.data.detalle_garantia.excepcion.file_name_efectivo;
            }

            setGarantiaData({
                id_detalle_garantia: response.data.detalle_garantia.id_garantia_detalle,
                revision_locatario: response.data.detalle_garantia.revision_locatario,
                revision_cobranza: response.data.detalle_garantia.revision_cobranza,
                revision_tesoreria: response.data.detalle_garantia.revision_tesoreria,
                estado_garantia: response.data.detalle_garantia.estado,
                nro_contrato: response.data.garantia.nro_contrato,
                ruc: response.data.garantia.ruc,
                razon_social: response.data.garantia.razon_social,
                nombre_comercial: response.data.garantia.nombre_comercial,
                nombre_mall: response.data.garantia.mall.nombre,
                tipo_garantia: response.data.detalle_garantia.tipo_garantia,
                nro_carta_fianza: response.data.detalle_garantia.nro_carta_fianza,
                nro_operacion: response.data.detalle_garantia.nro_operacion,
                nombre_banco: response.data.detalle_garantia.banco.nombre,
                codigo_banco: response.data.detalle_garantia.banco.codigo,
                codigo_moneda: response.data.garantia.moneda.codigo,
                importe: response.data.detalle_garantia.importe,
                fecha_emision_carta_fianza: response.data.detalle_garantia.fecha_emision_carta_fianza,
                fecha_vencimiento_carta_fianza: response.data.detalle_garantia.fecha_vencimiento_carta_fianza,
                url_filename_operacion: response.data.detalle_garantia.url_filename_operacion,
                url_filename_carta_fianza: response.data.detalle_garantia.url_filename_carta_fianza,
                is_excepcion: response.data.detalle_garantia.is_excepcion,
                excepcion: {
                    codigo_estado_excepcion: response.data.detalle_garantia.excepcion.codigo_estado_excepcion,
                    codigo_tipo_excepcion: response.data.detalle_garantia.excepcion.codigo_tipo_excepcion,
                    nombre_tipo_excepcion: response.data.detalle_garantia.excepcion.nombre_tipo_excepcion,
                    codigo_tipo_garantia_excepcion: response.data.detalle_garantia.excepcion.codigo_tipo_garantia_excepcion,
                    importe: response.data.detalle_garantia.excepcion.importe,
                    codigo_moneda: response.data.detalle_garantia.excepcion.codigo_moneda,
                    fecha_vencimiento: response.data.detalle_garantia.excepcion.fecha_vencimiento,
                    motivo: response.data.detalle_garantia.excepcion.motivo,
                    url_file_name_adjunto: response.data.detalle_garantia.excepcion.url_file_name_adjunto,
                    file_name_adjunto: response.data.detalle_garantia.excepcion.file_name_adjunto,
                    nro_operacion_efectivo: response.data.detalle_garantia.excepcion.nro_operacion_efectivo,
                    fecha_deposito_efectivo: response.data.detalle_garantia.excepcion.fecha_deposito_efectivo,
                    nro_carta_fianza: response.data.detalle_garantia.excepcion.nro_carta_fianza,
                    fecha_emision_carta_fianza: response.data.detalle_garantia.excepcion.fecha_emision_carta_fianza,
                    fecha_vencimiento_carta_fianza: response.data.detalle_garantia.excepcion.fecha_vencimiento_carta_fianza,
                    nombre_banco: nombreBanco,
                    url_file_name_adjunto_excepcion: urlFileNameAdjuntoExcepcion,
                    file_name_adjunto_excepcion: fileNameAdjuntoExcepcion,
                }

            })
        })
    }, [])

    const handleClick = useCallback(() => {
        if (user.role.id === GARANTIA_ROL.REVISOR_TESORERIA || user.role.id === GARANTIA_ROL.REVISOR_COBRANZA) {
            setShowModal(true);
        } else {
            cogoToast.error('Solo los usuarios con rol de "Revisor de Cobranza" o "Revisor de Tesorería" pueden aprobar o rechazar la Garantía.', {
                hideAfter: 5,
                heading: 'Aprobar/Rechazar',
                position: 'top-right'
            });
        }

    }, []);



    useEffect(() => {
        if (id) {
            getDetalleGarantiaLocatario(id)
        }
    }, [getDetalleGarantiaLocatario, id])

    const handleShowValidacionBancoModal = useCallback(() => {
        setShowValidacionBancoModal(true)
    }, []);

    const handleConfirmValidacionBanco = useCallback(() => {
        setIsLoadingValidacionBanco(true);
        queryClient.fetchQuery('validacionBancoEmail',
            () => ValidacionBancoEmail(id)).then((result) => {
                if (result.success) {
                    console.log('Se envio');
                    setIsErrorValidacionBanco(false);
                } else {
                    setIsErrorValidacionBanco(true);
                }
            }).catch((err) => {
                setIsErrorValidacionBanco(true);
            }).finally(() => {
                setIsLoadingValidacionBanco(false)
                setIsFinishValidacionBanco(true);
            });
    }, [id, queryClient]);

    const handleCloseValidacionBanco = useCallback(() => {
        setIsLoadingValidacionBanco(false);
        setIsFinishValidacionBanco(false);
    }, []);

    const breadcrumbs = [
        { title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false },
        { title: "", path: "", isActive: false, isSeparator: true },
        { title: "Garantías", path: "", isActive: false, isSeparator: false },
        { title: "", path: "", isActive: false, isSeparator: true },
        { title: "Revisión de Garantías", path: "/garantias/listado_garantias_revision", isActive: false, isSeparator: false },
    ];


    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs}>Aprobación de Garantía</PageTitle>
            <div className='max-width-xl-900'>
                <div className="row mb-3">
                    {/* <div className="col-4 container-action-secondary">
                    </div> */}
                    <div className="col-12 d-flex justify-content-end container-action-primary">
                        <Button
                            variant="primary"
                            onClick={handleClick}
                            size={'sm'}
                            disabled={garantiaData ? garantiaData.estado_garantia.codigo === GARANTIA_ESTADO.APROBADO : false}
                        >
                            <i className="fi fi-rr-memo-circle-check fs-3"></i>  Aprobar / Rechazar
                        </Button>
                        {garantiaData?.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA && (garantiaData?.codigo_banco === "BBVA" || garantiaData?.codigo_banco === "BCP") ? (
                            <Button
                                variant="secondary"
                                size={'sm'}
                                onClick={handleShowValidacionBancoModal}
                                disabled={garantiaData ? garantiaData.estado_garantia.codigo === GARANTIA_ESTADO.APROBADO : false}
                                className={"ms-4"}
                            >
                                <i className="fi fi-rr-paper-plane fs-3"></i>  Validar con banco
                            </Button>
                        ) : null
                        }

                    </div>

                </div>
                <GarantiaInfo garantia={garantiaData}></GarantiaInfo>
                {user.role.id === GARANTIA_ROL.REVISOR_TESORERIA && garantiaData && <CheckTesoreriaModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    onSuccess={() => getDetalleGarantiaLocatario(id)}
                    idDetalleGarantia={garantiaData.id_detalle_garantia} />}

                {user.role.id === GARANTIA_ROL.REVISOR_COBRANZA && garantiaData && <CheckCobranzaModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    onSuccess={() => getDetalleGarantiaLocatario(id)}
                    tipoGarantia={garantiaData?.is_excepcion && garantiaData?.excepcion?.codigo_estado_excepcion == "APR"
                        ? garantiaData?.excepcion?.codigo_tipo_garantia_excepcion
                        : garantiaData?.tipo_garantia?.codigo}
                    idDetalleGarantia={garantiaData.id_detalle_garantia} />}
            </div>

            <ConfirmWithLoader
                showModal={showValidacionBancoModal}
                setShowModal={setShowValidacionBancoModal}
                title={"Validación de Banco"}
                isLoading={isLoadingValidacionBanco}
                isFinish={isFinishValidacionBanco}
                textButton={"Enviar"}
                textButtonCancel="Cerrar"
                onConfirm={handleConfirmValidacionBanco}
                onClose={handleCloseValidacionBanco}>
                {!isLoadingValidacionBanco && isFinishValidacionBanco ? (
                    isErrorValidacionBanco ? (
                        <div className="d-flex align-items-center h-100">
                            <div className="d-flex align-items-center mx-2">
                                <i className="fi fi-rr-check-circle link-icon-alert"></i>
                            </div>
                            <div>
                                Error: No se puedo enviar el correo de validación al banco.
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex align-items-center h-100">
                            <div className="d-flex align-items-center mx-2">
                                <i className="fi fi-rr-check-circle link-icon-alert"></i>
                            </div>
                            <div>
                                Envio exitoso: Se envio el correo de validación al banco.
                            </div>
                        </div>
                    )
                ) : (
                    <div className="d-flex align-items-center h-100">
                        <div className="d-flex align-items-center mx-2">
                            <i className="fi fi-rr-comment-question link-icon-alert"></i>
                        </div>
                        <div>
                            Está seguro de enviar la garantia al Banco para su validación?
                        </div>
                    </div>
                )}
            </ConfirmWithLoader>
        </>

    )
}